export const ultraWideScreen = 2800;
export const wideScreen = 2100;
export const largeDesktop = 1600;
export const mediumDesktop = 1250;
export const desktop = 1100;
export const tablet = 991;
export const smallTablet = 768;
export const mobile = 600;
